import { useState } from "react";

export const KarmaPoolProfileManager = (local, setLocal, getURLBasePath) => {
    
    function fetchUserById(userId) {
        fetch(getURLBasePath() + 'user/' + userId, {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                setLocal(prevValue => {
                    if (prevValue.profiles === undefined) {
                        prevValue.profiles = {};
                    }

                    return { ...prevValue, profiles: { ...prevValue.profiles, [userId]: data } };
                });
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function follow(userId) {
        fetch(getURLBasePath() + 'user/' + userId + '/follow', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({ finished: true })
        })
            .then((data) => {
                console.log(data);

                fetchUserById(userId);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function unfollow(userId) {
        fetch(getURLBasePath() + 'user/' + userId + '/unfollow', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({ finished: true })
        })
            .then((data) => {
                console.log(data);

                fetchUserById(userId);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return {
        fetchUserById, follow, unfollow
    };
}